/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { CreateManualEntryMutationRequest, CreateManualEntryMutationResponse, CreateManualEntryPathParams, CreateManualEntry400, CreateManualEntry401, CreateManualEntry403, CreateManualEntry404, CreateManualEntry409, CreateManualEntry500 } from "../../types/financialHubController/CreateManualEntry.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { createManualEntry } from "../../client/financialHubController/createManualEntry.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const createManualEntryMutationKey = () => [{ url: '/api/organizations/:organizationId/financial/transactions/' }] as const

export type CreateManualEntryMutationKey = ReturnType<typeof createManualEntryMutationKey>

export function createManualEntryMutationOptions<TContext = unknown>(config: Partial<RequestConfig<CreateManualEntryMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = createManualEntryMutationKey()
        return mutationOptions<CreateManualEntryMutationResponse, ResponseErrorConfig<CreateManualEntry400 | CreateManualEntry401 | CreateManualEntry403 | CreateManualEntry404 | CreateManualEntry409 | CreateManualEntry500>, {organizationId: CreateManualEntryPathParams["organizationId"], data: CreateManualEntryMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ organizationId, data }) => {
            return createManualEntry(organizationId, data, config)
          },
        })

}

/**
 * @summary Create a manual ledger entry
 * {@link /api/organizations/:organizationId/financial/transactions/}
 */
export function useCreateManualEntry<TContext>(options: 
{
  mutation?: UseMutationOptions<CreateManualEntryMutationResponse, ResponseErrorConfig<CreateManualEntry400 | CreateManualEntry401 | CreateManualEntry403 | CreateManualEntry404 | CreateManualEntry409 | CreateManualEntry500>, {organizationId: CreateManualEntryPathParams["organizationId"], data: CreateManualEntryMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CreateManualEntryMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? createManualEntryMutationKey()

          const baseOptions = createManualEntryMutationOptions(config) as UseMutationOptions<CreateManualEntryMutationResponse, ResponseErrorConfig<CreateManualEntry400 | CreateManualEntry401 | CreateManualEntry403 | CreateManualEntry404 | CreateManualEntry409 | CreateManualEntry500>, {organizationId: CreateManualEntryPathParams["organizationId"], data: CreateManualEntryMutationRequest}, TContext>
          

          return useMutation<CreateManualEntryMutationResponse, ResponseErrorConfig<CreateManualEntry400 | CreateManualEntry401 | CreateManualEntry403 | CreateManualEntry404 | CreateManualEntry409 | CreateManualEntry500>, {organizationId: CreateManualEntryPathParams["organizationId"], data: CreateManualEntryMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<CreateManualEntryMutationResponse, ResponseErrorConfig<CreateManualEntry400 | CreateManualEntry401 | CreateManualEntry403 | CreateManualEntry404 | CreateManualEntry409 | CreateManualEntry500>, {organizationId: CreateManualEntryPathParams["organizationId"], data: CreateManualEntryMutationRequest}, TContext>
      
}